export default function HWY_Carousel() {
    const selectors = {
        block : '.hwy__carousel',
        image : '.carousel-image-wrap',
        text : '.carousel-text-wrap',
    }

    this.init = () => {
        jQuery(document).ready(function () {
            getCarouselBlock();
        });
    }
    const getCarouselBlock = () => {
        jQuery.each( jQuery( selectors.block ) , function ( indexInArray, valueOfElement ) { 
        const syncImage =  jQuery( valueOfElement.querySelector( selectors.image) );
        const syncText  =  jQuery( valueOfElement.querySelector( selectors.text) );
        syncTextSlide( syncImage, syncText );
        });
    }

    const syncTextSlide = ( syncImage, syncText ) => {
            var slidesPerPage = 1;
            var syncedSecondary = true;

            if( syncImage )
            syncImage.owlCarousel({
                items:1,
                loop:true,
                responsiveRefreshRate : 500,
                responsive:{
                    0:{
                        margin:25,
                    },
                    800:{
                        center: true,
                        items:2,
                        loop:true,
                        margin:57,
                        responsiveRefreshRate : 500,
                        autoWidth:true,
                    },
                    1024:{
                        center: true,
                        items:2,
                        loop:true,
                        margin:76,
                        responsiveRefreshRate : 500,
                        autoWidth:true,
                    }
                }
            }).on('changed.owl.carousel', syncPosition);
          
            if( syncText )
            syncText
              .on('initialized.owl.carousel', function () {
                syncText.find(".owl-item").eq(0).addClass("current");
              })
              .owlCarousel({
                items : slidesPerPage,
                dots: false,
                nav: false,
                smartSpeed: 200,
                slideSpeed : 500,
                slideBy: slidesPerPage,
                responsiveRefreshRate : 100,
                touchDrag: false,
                mouseDrag: false,
                pullDrag: false,
            }).on('changed.owl.carousel', syncPosition2);
          
            function syncPosition(el) {
              var count = el.item.count-1;
              var current = Math.round( el.item.index - ( el.item.count/2 ) - .5 );
              
              if(current < 0) {
                current = count;
              }
              if(current > count) {
                current = 0;
              }
              
              if( syncText )
              syncText
                .find(".owl-item")
                .removeClass("current")
                .eq(current)
                .addClass("current");
              var onscreen = syncText.find('.owl-item.active').length - 1;
              var start = syncText.find('.owl-item.active').first().index();
              var end = syncText.find('.owl-item.active').last().index();
              
              if (current > end) {
                syncText.data('owl.carousel').to(current, 100, true);
              }
              if (current < start) {
                syncText.data('owl.carousel').to(current - onscreen, 100, true);
              }
            }
            
            function syncPosition2(el) {
              if(syncedSecondary) {
                var number = el.item.index;
                syncImage.data('owl.carousel').to(number, 100, true);
              }
            }
            
            syncText.on("click", ".owl-item", function(e){
              e.preventDefault();
              var number = jQuery(this).index();
              syncImage.data('owl.carousel').to(number, 300, true);
            });
        
    }

    
}